import React, { Component } from "react";
import Link from "./link";
import SelectBox from "./selectBox";

class Links extends Component {
  renderItems() {
    return this.props.links.map((link, i) => (
      <Link key={i} link={link} id={"node" + this.props.nid + "_boxlink" + i} />
    ));
  }

  render() {
    if (window.innerWidth < 900) {
      return (
        <nav>
          <SelectBox links={this.props.links} />
        </nav>
      );
    } else {
      const ulStyle = {
        listStyle: "none",
        padding: "0",
        margin: 0,
        display: "flex",
        flexWrap: "wrap",
        position: "absolute",
        top: "25%"
      };
      return (
        <nav>
          <ul style={{ ...ulStyle }} className="menuButtons">
            {this.renderItems()}
          </ul>
        </nav>
      );
    }
  }
}
export default Links;
